<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    </div>

    <div class="request-list-card">
      <div class="request-header">
        <div>
          <div class="request-title">SOLICITUDES DE REGISTRO</div>
          <div class="request-subtitle">REVISION Y APROBACION DE ALTAS AUTONOMAS.</div>
        </div>

        <button mat-mini-fab color="primary" (click)="loadRequests()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <form [formGroup]="filterForm" class="row filter-row">
        <div class="col-md-3">
          <mat-form-field appearance="outline">
            <mat-label>ESTATUS</mat-label>
            <mat-select formControlName="estatus">
              <mat-option value="">TODOS</mat-option>
              <mat-option value="PENDIENTE">PENDIENTE</mat-option>
              <mat-option value="APROBADA">APROBADA</mat-option>
              <mat-option value="RECHAZADA">RECHAZADA</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field appearance="outline">
            <mat-label>TIPO</mat-label>
            <mat-select formControlName="tipoSolicitud">
              <mat-option value="">TODOS</mat-option>
              <mat-option value="MEDICO">MEDICO</mat-option>
              <mat-option value="PACIENTE">PACIENTE</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field appearance="outline">
            <mat-label>FOLIO</mat-label>
            <input formControlName="folio" matInput />
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field appearance="outline">
            <mat-label>EMAIL</mat-label>
            <input formControlName="email" matInput />
          </mat-form-field>
        </div>
      </form>

      <div class="filter-actions">
        <button mat-flat-button color="primary" (click)="loadRequests()">BUSCAR</button>
        <button mat-stroked-button color="primary" (click)="clearFilters()">LIMPIAR</button>
      </div>

      <div class="table-wrap" *ngIf="!loading; else loadingTpl">
        <table [dataSource]="requests" class="mat-table" mat-table>
            <ng-container matColumnDef="folio">
              <th *matHeaderCellDef mat-header-cell>FOLIO</th>
              <td *matCellDef="let row" mat-cell>{{ row.folio }}</td>
            </ng-container>

            <ng-container matColumnDef="tipo">
              <th *matHeaderCellDef mat-header-cell>TIPO</th>
              <td *matCellDef="let row" mat-cell>{{ row.tipoSolicitud }}</td>
            </ng-container>

            <ng-container matColumnDef="estatus">
              <th *matHeaderCellDef mat-header-cell>ESTATUS</th>
              <td *matCellDef="let row" mat-cell>
                <span class="status-chip" [class.pending]="row.estatus === 'PENDIENTE'" [class.approved]="row.estatus === 'APROBADA'">
                  {{ row.estatus }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="nombre">
              <th *matHeaderCellDef mat-header-cell>NOMBRE</th>
              <td *matCellDef="let row" mat-cell>{{ row.nombreCompleto }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th *matHeaderCellDef mat-header-cell>EMAIL</th>
              <td *matCellDef="let row" mat-cell>{{ row.email }}</td>
            </ng-container>

            <ng-container matColumnDef="fecha">
              <th *matHeaderCellDef mat-header-cell>ALTA</th>
              <td *matCellDef="let row" mat-cell>{{ row.fechaCreacionUtc | date:'yyyy-MM-dd HH:mm' }}</td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th *matHeaderCellDef mat-header-cell>ACCIONES</th>
              <td *matCellDef="let row" mat-cell>
                <div class="action-row">
                  <button mat-stroked-button color="primary" (click)="openRequestDetail(row)">VER</button>
                  <button
                    mat-stroked-button
                    color="warn"
                    *ngIf="row.estatus === 'PENDIENTE'"
                    [disabled]="approvingId === row.idSolicitudRegistro"
                    (click)="reject(row)">
                    RECHAZAR
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    *ngIf="row.estatus === 'PENDIENTE'"
                    [disabled]="approvingId === row.idSolicitudRegistro"
                    (click)="approve(row)">
                    {{ approvingId === row.idSolicitudRegistro ? 'APROBANDO...' : 'APROBAR' }}
                  </button>
                </div>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        </table>

        <div class="empty-state" *ngIf="!requests.length">
          NO HAY SOLICITUDES CON LOS FILTROS ACTUALES.
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #loadingTpl>
  <div class="loading-state">
    <mat-progress-spinner color="primary" [diameter]="38" mode="indeterminate"></mat-progress-spinner>
  </div>
</ng-template>
